import React from 'react';
import { EnquiryProvider } from './contexts/EnquiryContext';
import { Home } from './pages/Home';
export function App() {
  return <EnquiryProvider data-id="element-0" data-mp="35bsdit06cyr4">
      <Home data-id="element-1" data-mp="35eoe6p3eq1j9" />
    </EnquiryProvider>;
}